
import { Component } from 'vue-property-decorator';
import { RouteConfig } from 'vue-router';
import SubModule from '../../components/SubModule.vue';
import routes from './routes';
import { store } from './store';
import { EntityStoreGetters } from '@/base';
import { IMenuItem } from '../../components/Menu.vue';

@Component
export default class BankAccountTransaction extends SubModule
{
  private get activeItem(): typeof store[EntityStoreGetters.ACTIVE_ITEM]
  {
    return store[EntityStoreGetters.ACTIVE_ITEM];
  }

  protected _getRoutes(): RouteConfig[]
  {
    return routes;
  }

  protected _getDynamicMenuItems(): IMenuItem[]
  {
    const activeItem = this.activeItem;
    const items: IMenuItem[] = [];
    return items;
  }
}
